module.exports = "/images/cash2.svg?90365a8aac181dff63308acbd7f539d2";